module.exports = __webpack_public_path__ + "img/tobacco-pipes.4aefff8f.webp";